import { AuthStore } from 'src/app/stores/auth.store';
import FormatCurrency from 'src/app/utils/format-currency-utils';
import { computed, effect, inject, Injectable } from '@angular/core';
import { AssetStore } from 'src/app/stores/asset.store';
import { FormatPriceUtils } from './format-price-utils';
import { CurrencyMaskConfig } from 'ng2-currency-mask';

@Injectable({
  providedIn: 'root',
})
export class InputMaskUtils {
  constructor() {
    effect(() => {
      this.updateMaskConfig();
    });
  }

  private formatCurrency = inject(FormatCurrency);
  private assetStore = inject(AssetStore);
  private AuthStore = inject(AuthStore);
  private formatPriceUtils = inject(FormatPriceUtils);

  public customCurrencyMaskConfig!: CurrencyMaskConfig | any;

  public decimalSeparator = computed(() => {
    return this.formatPriceUtils.isCommaDecimal() ? ',' : '.';
  });

  public thousandsSeparator = computed(() => {
    return this.formatPriceUtils.isCommaDecimal() ? '.' : ',';
  });

  updateMaskConfig() {
    this.customCurrencyMaskConfig = {
      align: 'left',
      allowNegative: false,
      prefix: '',
      suffix: '',
      decimal: this.decimalSeparator(),
      thousands: this.thousandsSeparator(),
    };
  }

  getInputMask(assetTicker: string): CurrencyMaskConfig {
    return {
      ...this.customCurrencyMaskConfig,
      precision:
        this.assetStore.decimalPlacesFor()[assetTicker] ||
        this.assetStore.decimalPlacesFor()[assetTicker.split('.')[1]],
    };
  }
}
